import { useMe } from '@crehana/auth';
import type { TTimeline } from '@crehana/compass.dashlets';

import { useGetTimeLineQuery } from './graphql/get-timeline.v5.generated';

type Props = {
  month: number;
  year: number;
};

export const useGetTimeline = ({ month, year }: Props) => {
  const { me, talentUser } = useMe();

  const { loading, error, data, refetch } = useGetTimeLineQuery({
    variables: {
      input: {
        company_id: talentUser.company_id_talent || 0,
        user_email: me?.email,
        month_number: month + 1,
        year_number: year,
      },
    },
    context: {
      clientName: 'v5',
      credentials: 'omit',
    },
    skip: !me?.email || !talentUser.company_id_talent,
  });

  return {
    loading: loading || me?.loading || talentUser.loading,
    error,
    refetch,
    dataTimeLine: data?.talent.talent_dashboard.talent_dashboard_collaborator
      .get_talent_dashboard_collaborator_timeline as TTimeline,
  };
};
